import axios from '../../plugins/FinanceiroInterceptor'

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}
export const actions = {
    faturasAgrupadoReferencia(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`faturas/mensalidades-agrupadas-referencia` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    faturasPorReferencia(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`faturas/mensalidades-por-referencia`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selecionar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/selecionar', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    selecionarTodasFaturas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/selecionar-todos', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    retornarQuantidadeSelecionadas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('faturas/selecionadas' + payload.referencia)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    alterarDataVencimento(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/alterar-data-vencimento', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    alterarEmissao(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/alterar-data-emissao', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    enviarFaturas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/enviar-faturas', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    estornarPreFat(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/estorno-pre-fatura', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    obterFatura(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('faturas/' + payload.id)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    boletoUnico(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('faturas/boleto-unico', payload)
                .then(function (res) {
                    resolve(res)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    }

}



// WEBPACK FOOTER //
// ./src/store/modules/faturas.js